<template>
  <div class="Instructor-modal-overlay">
        <transition name="modal-expand">
        <div v-if="isVisible" class="Instructor-modal" @click.stop>
      <div class="modal-content">
          <div class="title-container">
            <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
            <h2>Assign Instructors to {{ $labels.project }}</h2>
          </div>
          <div class="flex-grow-1 d-flex justify-content-center">
            <div v-if="isDisabled" class="expired-box">
              This {{ $labels.project }} has expired. Instructors can no longer be assigned.
            </div>
          </div>
          <div class="container-fluid">
            <vue-good-table :columns="columns" :rows="filteredInstructors"
              :pagination-options="{ enabled: true, perPage: 10 }" :search-options="{ enabled: true }"
              :sort-options="{ enabled: true }" styleClass="vgt-table condensed">
              <template #table-row="props">
                <!-- Assign Checkbox -->                
                <template v-if="props.column.field === 'select'">
                  <div @click="toggleCheckbox(props.row.user_id)">
                    <input type="checkbox" v-model="selectedInstructors" :value="props.row.user_id" @click.stop />
                  </div>
                </template>
                <!-- Default -->
                <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
                  {{ props.formattedRow[props.column.field] }}
                </span>

              </template>
            </vue-good-table>
          </div>
          <div class="button-container">
            <button class="ins-close-button" @click="close()">Close</button>
            <button class="ins-save-button" @click="selectInstructors">Assign
              Instructors</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
//import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';

export default {
  name: 'SelectInstructorsModal',
  components: {
    VueGoodTable,
  },
  props: {
    propInstructors: {
      type: Array,
      required: true,
    },
    initialSelectedInstructors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      instructors: [],
      selectedInstructors: [],
      columns: [
        { label: 'ID', field: 'user_id', sortable: true, thClass: 'vgt-id-column', tdClass: 'vgt-id-column' },
        { label: 'First Name', field: 'first_name', sortable: true, thClass: 'vgt-first-name-column', tdClass: 'vgt-first-name-column' },
        { label: 'Last Name', field: 'last_name', sortable: true, thClass: 'vgt-last-name-column', tdClass: 'vgt-last-name-column' },
        { label: 'Email', field: 'email', sortable: true, thClass: 'vgt-email-column', tdClass: 'vgt-email-column' },
        { label: 'Select Instructor', field: 'select', sortable: false, type: 'html', thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
        { label: 'Remove Instructor', field: 'remove', sortable: false, type: 'html', thClass: 'vgt-actions-column', tdClass: 'vgt-actions-column' },
      ],
      isVisible: false,
    };
  },
  computed: {
    filteredInstructors() {
      return this.instructors;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    toggleCheckbox(userId) {
      const index = this.selectedInstructors.indexOf(userId);
      if (index > -1) {
        this.selectedInstructors.splice(index, 1);
      } else {
        this.selectedInstructors.push(userId);
      }
    },
    selectInstructors() {
      this.$emit('instructors-selected', this.selectedInstructors);
      this.close(); // Close the modal after selection
    },
  },
async mounted() {
    this.isVisible = true;
    this.instructors = this.propInstructors;
    this.selectedInstructors = this.initialSelectedInstructors;
    console.log(this.instructors);
    console.log(this.propInstructors);
  }
};
</script>

<style scoped>
.modal-content h2 {
    font-size: 30px;
    margin-left: 20px;
}

.Instructor-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: top;
  width: 100%;
  height: 100vh;
  z-index: 1;
}

.Instructor-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 20px;
  max-width: 90vw;
  max-height: 94vh;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 0px;
}

.ins-save-button {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0px;
  margin-right: 20px;
  border: 1px solid rgb(0, 96, 134);
  border-radius: 5px;
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  margin-top: 0px;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 20px;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-save-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.title-container {
  margin-top: 10px;
  margin-bottom: 15px;
}
</style>